// extracted by mini-css-extract-plugin
export default {"addAccessButton":"add-access-button_addAccessButton__WzPKl"};